import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2, Anchor } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--mia-navy)] p-6" data-testid="admin-login">
      <div className="w-full max-w-md bg-white rounded-2xl p-10 shadow-2xl">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-full bg-[color:var(--mia-navy)] text-[color:var(--mia-gold)] flex items-center justify-center"><Anchor className="w-5 h-5" /></div>
          <div>
            <div className="font-display font-black text-[color:var(--mia-navy)]">MARINE INFRASTRUCTURE</div>
            <div className="text-[0.68rem] font-bold text-[color:var(--mia-gold)] tracking-[0.28em]">ADMIN · AFRICA</div>
          </div>
        </div>
        <h1 className="font-display text-3xl font-black text-[color:var(--mia-navy)] tracking-tight leading-tight">Sign in to admin</h1>
        <p className="text-[color:var(--mia-muted)] mt-2 text-sm">Manage solutions, projects, blog posts and enquiries.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-4 py-3.5 border border-slate-200 rounded-lg focus:outline-none focus:border-[color:var(--mia-blue)]" data-testid="admin-email" />
          <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-4 py-3.5 border border-slate-200 rounded-lg focus:outline-none focus:border-[color:var(--mia-blue)]" data-testid="admin-password" />
          <button type="submit" disabled={loading} className="mia-btn mia-btn-secondary w-full justify-center" data-testid="admin-submit">
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Signing in…</> : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
